import type { ElibooApp, PageResult } from '@eliboo/api-models';
import type { CommonHttpOptions } from '@eliboo/api/common';

import { HttpClient } from '@angular/common/http';
import { inject, signal } from '@angular/core';
import { mergeOptions } from '@eliboo/api/common';

export function useApiPageApplicationVersion(defaultOptions?: CommonHttpOptions) {
  const http = inject(HttpClient);
  const url = signal(`/eliboo-app-boot/app-api/v1/applicationVersion/listCondition`);
  function api(body: ElibooApp.ApplicationVersionVO, httpOptions?: CommonHttpOptions) {
    const options = mergeOptions(defaultOptions, httpOptions);
    return http.post<PageResult<ElibooApp.ApplicationVersionDTO>>(url(), body, options);
  }
  return { url, api };
}
